import { buildInterviewPayload } from 'features/sendouts/common/utils';
import { prepareFormToSubmit } from 'UI/utils/forms';

import { OTHER_INTERVIEWER_FORM_FIELDS_MAP } from './CreateSendoutInterviewForm/CreateSendoutInterviewForm.constants';

const REMINDER_FIELD_KEYS = [
  'candidateTwentyFourHoursReminder',
  'hiringAuthorityTwentyFourHoursReminder',
  'candidateOneHourReminder',
  'hiringAuthorityOneHourReminder'
];

export const buildCreateSendoutInterviewPayload = (formData = {}) => {
  const otherInterviewerPayload = prepareFormToSubmit(formData, OTHER_INTERVIEWER_FORM_FIELDS_MAP);
  const { cc_emails: ccs, email, full_name: fullName } = otherInterviewerPayload;

  return {
    interview: {
      ...buildInterviewPayload(formData),
      ccs,
      otherInterviewer: {
        email,
        full_name: fullName
      }
    },
    ...REMINDER_FIELD_KEYS.reduce(
      (reminders, key) => ({ ...reminders, [key]: !!formData[key] }),
      {}
    )
  };
};
